import { Auth } from '@leagueplatform/auth';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { captureAppMessage } from '@leagueplatform/observability';
import { SENTRY_CONSTANTS } from 'common/constants';
import {
  isImpersonationSession,
  endImpersonationSession,
  getLogoutReturnUrl,
} from './impersonation-storage';

export async function logout(returnUrl: string): Promise<void> {
  try {
    const token = await Auth.getToken();
    const isImpersonation = isImpersonationSession();

    const logoutOptions = {
      federated: !isImpersonation,
      accessToken: token,
      returnTo: getLogoutReturnUrl(returnUrl),
    };

    await StandaloneAuth.client.logout(logoutOptions);
    endImpersonationSession();
  } catch (error: any) {
    captureAppMessage(`Logout Error - ${error.name}`, {
      context: {
        contextDetails: {
          info: `An exception occurred during logout. Error: ${error.message}`,
        },
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      severityLevel: 'error',
    });
  }
}
